import React, { Component } from 'react';
import { Grid,Row,Col,Image } from 'react-bootstrap';
import './Contacts.css';
import mailicon from './mail-4.png'
import fbicon from './facebook-logo-626.jpg'
import igicon from './instagram.png'

class Contacts extends Component {
  render() {
    document.title = 'Contact Us - NaleyCards'
    return (
      <Grid fluid>
        <Row>
          <Col xs={0} sm={0} md={0} lg={2}></Col>
          <Col xs={12} sm={12} md={12} lg={10}><h3>NaleyCards PLT</h3> <h6>(LLP0016798-LGN)</h6></Col>
        </Row>
        <Row>
          <Col xs={0} sm={0} md={0} lg={2}></Col>
          <Col xs={12} sm={12} md={12} lg={10}>
            <h4>+60 12 404 5240</h4>
          </Col>
        </Row>
        <Row>
          <Col xs={0} sm={0} md={0} lg={2}></Col>
          <Col xs={12} sm={5} md={5} lg={3}>
            <a href="mailto:hello@naleycards.com" className="contacts">
              <Image src={mailicon} width={18}/>&nbsp;hello@naleycards.com
            </a>
          </Col>
          <Col xs={12} sm={4} md={4} lg={3} className="contacts">
            <a href="https://www.facebook.com/NaleyCards/">
              <Image src={fbicon} width={18}/>&nbsp;naleycards
            </a>
          </Col>
          <Col xs={12} sm={3} md={3} lg={4} className="contacts">
            <a href="https://www.instagram.com/naleycards/">
              <Image src={igicon} width={20}/>&nbsp;naleycards
            </a>
          </Col>
        </Row>
      </Grid>
    )
  }
}

export default Contacts;
